import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { iDocumentoPdfConfiguracionService } from './ports/i-documento-pdf-configuracion-service';


@Injectable({
  providedIn: 'root'
})
export class DocumentoPdfConfiguracionApiService implements iDocumentoPdfConfiguracionService{

  private readonly URL_GET_FICHERO_TEMPORAL: string = this.endpointService.UrlGetUrlFileTemporal;
  private readonly URL_SUBE_FICHERO_TEMPORAL: string = this.endpointService.UrlApiSubeFicheroTemporal
  private readonly URL_GET_CIF_DOCUMENTO: string = this.endpointService.UrlGetCifDocumento
  private readonly URL_GET_NIF_DOCUMENTO: string = this.endpointService.UrlGetNifDocumento

  /** Cache SAS: id → url + caducidad. TTL < SasUrlMinutesExpiration (30). */
  private readonly sasCache = new Map<string, { url: string; expiresAt: number }>();
  private readonly SAS_CACHE_TTL_MS = 25 * 60 * 1000;

  constructor(private endpointService: EndpointService,
              private loginService: LoginService,
              private client: HttpClient,
              private _snackBar: MatSnackBar) { }

  //api real se tiene que implementar aún
  putDocumentoTemporal(file: FileList): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    const formData = new FormData();
    let fileName = this.normalizaNombreFichero(file[0].name);
    formData.append('file', file[0], fileName);
    return this.client.post(this.URL_SUBE_FICHERO_TEMPORAL,formData, options).pipe(
      map((response: any) => {
        // 2.0.d — invalidar cache SAS tras Sube (id nuevo o reemplazo)
        this.sasCache.clear();
        return response.Id;
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'Se ha producido un error al subir el fichero';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.error && typeof error.error === 'string') { 
          errorMessage = error.error;
          
        } else if (error.message) {
          errorMessage = error.message;
        }
        this._snackBar.open(errorMessage, 'Cerrar', {duration: 4000});
        return throwError(() => error);
      })
    );
  }


  getDocumentoTemporal(id: string): Observable<string> {
    const cached = this.sasCache.get(id);
    if (cached && cached.expiresAt > Date.now()) {
      return of(cached.url);
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.get(this.URL_GET_FICHERO_TEMPORAL.replace("{id}", id), options).pipe(
      map((response: any) => {
        if (response?.Url) {
          return response.Url as string;
        }
        return '';
      }),
      tap((url: string) => {
        if (url) {
          this.sasCache.set(id, {
            url,
            expiresAt: Date.now() + this.SAS_CACHE_TTL_MS
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'No se ha encontrado el documento asociado. Vuelva a subir el documento.';
        if (error.error && typeof error.error === 'string') {
          errorMessage = error.error;
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this._snackBar.open(errorMessage, 'Cerrar', {duration: 4000});
        return throwError(() => error);
      })
    );
  }

  traeCif(id: string, pagina: number, orden: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.get(this.URL_GET_CIF_DOCUMENTO.replace("{idDocumento}", id).replace("{page}", pagina.toString()).replace("{orden}", orden.toString()), options).pipe(
      map((response: any) => {
        if (response?.CifNif) {
          return response.CifNif as string;
        }
        return '';
      })
    );
  }

  traeNif(id: string, pagina: number, orden: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    if(id!==null && pagina==null && orden==null){ //cambiar cuando se pueda recuperar el Nif a través del formulario
      return of('');
    }else
    return this.client.get(this.URL_GET_NIF_DOCUMENTO.replace("{idDocumento}", id).replace("{page}", pagina.toString()).replace("{orden}", orden.toString()), options).pipe(
      map((response: any) => {
        if (response?.CifNif) {
          return response.CifNif as string;
        }
        return '';
      })
    );
  }

  normalizaNombreFichero(fileName: string): string {
    return fileName.replace(/[^a-zA-Z0-9 _\-\.]+/g, "");
  }
}

// return `https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf`
